<template>
    <div>
        <v-tooltip top transition="v-fab-transition">
            <template #activator="{ on, attrs }">
                <v-btn
                    v-if="can('api.v1.patients.store') && can('patients.create') && can('upload-from-pdf.index')"
                    color="primary"
                    icon
                    v-bind="attrs"
                    :loading="loading"
                    v-on="on"
                    @click="$refs.fileInput.$children[0].$refs.input.click()"
                >
                    <v-icon>mdi-download-box-outline</v-icon>
                </v-btn>
            </template>
            <span>{{ t('patients::button.upload_from_pdf') }}</span>
        </v-tooltip>
        <div>
            <v-form>
                <b-file-input
                    ref="fileInput"
                    to-mutate="uploadPdf::form.file"
                    :label="t('quality-control::date.file')"
                    accept=".pdf"
                    mandatory
                    class="file d-none"
                    :prepend-icon="null"
                    :rules="validationRules.file"
                    @change="processFile"
                ></b-file-input>
            </v-form>
        </div>
    </div>
</template>

<script>
const UploadFromPdfMixin = require(process.env.MIX_APP_ROOT +
    '/modules/patients/resources/js/mixins/UploadFromPdfMixin.js').default;
export default {
    mixins: [UploadFromPdfMixin],
};
</script>

<style></style>
